import {
  PassengerType,
  UnitPositionType,
  UnitStatus,
} from 'src/graphql/generated/graphql.generated';
import { UnitRecord } from 'src/store/generated/unit-record.generated';

export function unitNumber(unit: UnitRecord): number {
  const abbreviation = unit.abbreviation;
  const parts = abbreviation.split(' ');
  if (parts != null && parts.length > 1) {
    const num = Number(parts[1]);

    if (!isNaN(num)) {
      return num;
    }
  }

  return -1;
}

// Obsolete - use UnitViewModel.unitNumberStr instead
export function unitNumberStr(unit: { abbreviation: string; status: UnitStatus }): string {
  const abbreviation = unit.abbreviation;
  const parts = abbreviation.split(' ');
  if (parts != null && parts.length > 1) {
    return parts[1];
  }

  return abbreviation;
}

export function toPassengerType(type: UnitPositionType) {
  if (type === UnitPositionType.Pilot) {
    return PassengerType.PilotInCommand;
  } else {
    return PassengerType.CrewMember;
  }
}
